//
// Copyright (c) 2021 Astute Global, Inc.
//

import { Plugin } from "ckeditor5";
import CreateCustomTemplateCommand from "./createCustomTemplateCommand";
import InsertCustomTemplateCommand from "./insertCustomTemplateCommand";
import DeleteCustomTemplateCommand from "./deleteCustomTemplateCommand";

export default class CustomTemplateEditing extends Plugin {
  // noinspection JSUnusedGlobalSymbols
  static get requires() {
    return [];
  }

  // noinspection JSUnusedGlobalSymbols
  static get pluginName() {
    return "CustomTemplateEditing";
  }

  init() {
    // No custom elements involved.  Templates are simply document fragments
    this.editor.commands.add("createCustomTemplate", new CreateCustomTemplateCommand(this.editor));
    this.editor.commands.add("deleteCustomTemplate", new DeleteCustomTemplateCommand(this.editor));
    this.editor.commands.add("insertCustomTemplate", new InsertCustomTemplateCommand(this.editor));
  }
}
